import { permissionCheck, realPermissionCheck } from "./permission-check";

export const buildRegionAdmin = (navigation, strings,permissions,onClick, flags = []) => {
  let baseUrl = `/areas/${navigation.area.id}/regions/${navigation.region.id}`;
  const item = {
    type: "group",
    label: strings.programAdministration,
    "data-id": "accordion-region-admin-group",
    items: [],
  };
  const items = item.items;
  if (permissionCheck(navigation, "readRegionFaculty")) {
    items.push({
      id:19,
      type: "link",
      "data-id": "accordion-region-admin-faculty",
      label: strings.faculty,
      href: `${baseUrl}/faculty`,
      onClick:(e) => {
        onClick({
          event:e,
          href: `${baseUrl}/faculty`,
        });
      }
    });
  }
  const canManage = realPermissionCheck(permissions, "CanEditProgramSupplemental", navigation.region.id);

  if (canManage) {
    item.items.push({
      id:20,
      type:"link",
      label: strings.instituteHubs,
      "data-id":"accordian-institute-hubs",
      href:`${baseUrl}/institute-hubs`,
      onClick:(e) => {
        onClick({
          event:e,
          href: `${baseUrl}/institute-hubs`,
        });
      }
    });
  }

  return item;
};
